<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">

      <a-form-model-item label="观看时长(min)" prop="lookTime" >
        <a-input-number style="width: 20%" :min="0" :step="0" v-model="form.lookTime" placeholder="请输入观看时长(min)" />
      </a-form-model-item>
      <a-form-item label="类型" prop="type">
        <a-select placeholder="请选择类型" v-model="form.type" allow-clear>
          <a-select-option :value=0>钻石</a-select-option>
          <a-select-option :value=1>优惠券</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-model-item label="奖励钻石数" prop="giveNum" v-if="form.type == 0" >
        <a-input-number style="width: 20%" :min="0" :step="0" v-model="form.giveNum" placeholder="请输入奖励钻石数" />
      </a-form-model-item>
      <a-form-model-item label="优惠券ID" prop="couponId" v-if="form.type == 1">
        <a-select placeholder="请选择优惠券ID" v-model="form.couponId" allow-clear>
          <a-select-option v-for="item in couponList" :value="item.id">{{item.couponName}}</a-select-option>
        </a-select>
      </a-form-model-item>


      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getLookReward, addLookReward, updateLookReward } from '@/api/lookReward/lookReward'
import { listCoupon } from '@/api/coupon/coupon'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 优惠券列表
      couponList: [],
      // 表单参数
      form: {
        id: null,

        userId: null,

        lookTime: null,

        giveNum: null,

        isBan: null,

        remark: null,

        createTime: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
    this.getCouponList()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    // 获取优惠券列表
    getCouponList() {
      listCoupon({notType: 3}).then(res => {
        this.couponList = res.data
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        lookTime: null,
        giveNum: null,
        isBan: null,
        remark: null,
        createTime: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLookReward({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateLookReward(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addLookReward(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
